import { Button } from "primereact/button";
import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import DropDown from "./DropDown";
import { delimitationService } from "../services/DelimitationService";
import { usersService } from "../services/UsersService";
import { MultiSelect } from "primereact/multiselect";
import { Tree } from "primereact/tree";
import { BehaviorSubject } from "rxjs";

export default function RegistrationDelimitationSelector({ show = false, selectedUser, userDelimitations, onHide, onSubmit, isNational,demarcationTypeID }) {
	const toast = useRef(null);


	var [loading, setLoading] = useState(false);
	var [district, setDistrict] = useState("");

	var [nodes, setNodes] = useState([]);
	var [selectedKeys, setSelectedKeys] = useState({});
	var [oldSelectedKeys, setOldSelectedKeys] = useState({});
	var [manualSelectedPolDivision, setManualSelectedPolDivision] = useState([]);

	function getPreSelectedIds() {
		var ids = {};
		userDelimitations.forEach((delimtation) => {
			if (delimtation.delimitationLevelID == 1) {
				ids["1-" + delimtation.districtID] = { checked: true, partialChecked: false };

			} else if (delimtation.delimitationLevelID == 2) {
				ids = PartialCheckIfNotChecked(ids, "1-" + delimtation.districtID);
				ids["2-" + delimtation.constituencyID + "-" + delimtation.districtID] = { checked: true, partialChecked: false };

			} else if (delimtation.delimitationLevelID == 3) {
				ids = PartialCheckIfNotChecked(ids, "1-" + delimtation.districtID);
				ids = PartialCheckIfNotChecked(ids, "2-" + delimtation.constituencyID + "-" + delimtation.districtID);
				ids["3-" + delimtation.pollingDivisionID + "-" + delimtation.constituencyID] = { checked: true, partialChecked: false };


			} else if (delimtation.delimitationLevelID == 4) {
				ids = PartialCheckIfNotChecked(ids, "1-" + delimtation.districtID);
				ids = PartialCheckIfNotChecked(ids, "2-" + delimtation.constituencyID + "-" + delimtation.districtID);
				ids = PartialCheckIfNotChecked(ids, "3-" + delimtation.pollingDivisionID + "-" + delimtation.constituencyID);
				ids[delimtation.delimitationLevelID + "-" + delimtation.registrationCentreID + "-" + delimtation.pollingDivisionID] = { checked: true, partialChecked: false };
			}
		});

		return ids;
	}

	function PartialCheckIfNotChecked(ids, key) {
		if (ids[key] && ids[key].checked) {
			ids[key] = { checked: true, partialChecked: false };
		}
		else {
			ids[key] = { checked: false, partialChecked: true };
		}
		return ids;
	}
	function PreselectActiveDelimitationNodes(key) {
		setSelectedKeys(getPreSelectedIds());
		setOldSelectedKeys(getPreSelectedIds());
	}
	function getDistricts() {
		setLoading(true);
		try {
			delimitationService.getNationalLocalDistrict(isNational).then((response) => {
				var districts = [];
				response.forEach((e) => {
					districts.push({
						key: "1-" + e.id,
						label: e.code + " - " + e.name,
						checked: true,
						leaf: false
					});
				});
				setNodes(districts);
				PreselectActiveDelimitationNodes("");
				setLoading(false);
			});
		} catch (error) {
			setLoading(false);
		}
	}

	function isValid() {
		return district !== "";// && constituency !== "" && pollingDivision !== "" && registrationCentre !== "";
	}

	function submit() {
		setLoading(true);
		//data comes like key: Id-Level-Parent
		var Districts = [];
		var Constituances = [];
		var PollingDivisions = [];
		var RegistrationCentres = [];


		//to visually show the user active delimitaations, I had to manually select the nodes.
		//the part is removing those manually selected nodes.nodes.
		var newSelectedKeys = {};
		Object.keys(selectedKeys).forEach((el) => {
			if (!oldSelectedKeys[el]) {
				newSelectedKeys[el] = selectedKeys[el];
			}
		});


		//The behavor of the tree is that if a child is selected, then the parrents will as well be selected.
		//if the parent is selected, the children will also be selected.
		//this logic is grouping all keys to the their level objects 

		Object.keys(newSelectedKeys).forEach((x) => {
			var temp = x.split("-");
			if (temp.length == 2 && !Districts.find((x) => x.Id == temp[1]) && selectedKeys[x].checked) {
				Districts.push({
					Id: temp[1],
					Level: temp[0]
				});
			} else if (
				temp[0] == 2 &&
				!Constituances.find((x) => x.Id == temp[1]) &&
				selectedKeys[x].checked &&
				!Districts.find((x) => x.Id == temp[2])
			) {
				Constituances.push({
					Id: temp[1],
					Level: temp[0],
					ParentID: temp[2]
				});
			} else if (
				temp[0] == 3 &&
				!PollingDivisions.find((x) => x.Id == temp[1]) &&
				selectedKeys[x].checked &&
				!Districts.find((x) => x.Id == temp[2]) &&
				!Constituances.find((x) => x.Id == temp[2]) &&
				manualSelectedPolDivision.indexOf(x) >= 0
			) {
				PollingDivisions.push({
					Id: temp[1],
					Level: temp[0],
					ParentID: temp[2]
				});
			} else if (
				temp[0] == 4 &&
				!RegistrationCentres.find((x) => x.Id == temp[1]) &&
				selectedKeys[x].checked &&
				!Districts.find((x) => x.Id == temp[2]) &&
				!Constituances.find((x) => x.Id == temp[2]) &&
				!PollingDivisions.find((x) => x.Id == temp[2])
			) {
				RegistrationCentres.push({
					Id: temp[1],
					Level: temp[0],
					ParentID: temp[2]
				});
			}
		});

		//this logic is filtering out that and will remain with only the delimitation keys(ids and levels) 
		//that need to go to the database.
		var finalIds = [...Districts];
		var ignoredParents = [];

		Constituances.forEach((e) => {
			if (!finalIds.find((x) => x.Id == e.ParentID && x.Level == "1")) {
				finalIds.push({ Id: e.Id, Level: e.Level });
			} else {
				ignoredParents.push({ Id: e.Id, Level: e.Level });
			}
		});

		PollingDivisions.forEach((e) => {
			if (!finalIds.find((x) => x.Id == e.ParentID && x.Level == "2") && !ignoredParents.find((x) => x.Id == e.ParentID && x.Level == "2")) {
				finalIds.push({ Id: e.Id, Level: e.Level });
			} else {
				ignoredParents.push({ Id: e.Id, Level: e.Level });
			}
		});

		RegistrationCentres.forEach((e) => {
			if (!finalIds.find((x) => x.Id == e.ParentID && x.Level == "3") && !ignoredParents.find((x) => x.Id == e.ParentID && x.Level == "3")) {
				finalIds.push({ Id: e.Id, Level: e.Level });
			}
		});

		var payload = [];
		finalIds.forEach((e) => {
			payload.push({
				UserID: selectedUser.userID,
				DelimitationID: e.Id,
				DelimitationLevelID: e.Level,
				demarcationTypeID:demarcationTypeID
			});
		});
		onSubmit(payload);
	}

	function SetSelectedNodesIds(value) {
		setSelectedKeys(value);
	}

	function ResponseToChildren(response, level, parentID) {
		var children = [];

		response.forEach((e) => {
			children.push({
				key: level + "-" + e.id + "-" + parentID,
				label: e.code + " - " + e.name,
				leaf: level == 4 ? true : false
			});
		});

		return children;
	}

	//when selecting the last level(voting station) node on the tree and if that node is the only child,
	//the parent is fully selected which will mean the person being added will have access to the parent(voting district) 
	//wich will include every station in it. This logic is to keep track of those manually selectd station to avoid that.
	const onSelect = (event) => {
		if (oldSelectedKeys[event.node.key]) {
			delete (oldSelectedKeys[event.node.key]);
			setOldSelectedKeys(oldSelectedKeys);
		}
		if (event.node.key.split("-")[0] == 3 && !manualSelectedPolDivision.find((x) => x.key == event.node.key)) {
			manualSelectedPolDivision.push(event.node.key);
		}
	};
	const onUnselect = (event) => {
		var keyIndex = manualSelectedPolDivision.indexOf(event.node.key);
		if (event.node.key.split("-")[0] == 3 && keyIndex >= 0) {
			manualSelectedPolDivision.splice(keyIndex);
		}
	};

	function PreselectOnExpand(node) {
		if (selectedKeys[node.key] && selectedKeys[node.key].checked) {
			var ids = { ...selectedKeys }
			node.children.forEach((e) => {
				if (!selectedKeys[e.key]) {
					ids[e.key] = { checked: true, partialChecked: false };
				}
			});
			setSelectedKeys(ids);
		}
	}
	function NodeExand(e) {
		var keys = e.node.key.split("-");
		var parentID = keys[1];
		var level = keys[0];

		if (level == 1) {
			delimitationService.getNationalLocalConstituency(isNational, parentID).then((response) => {
				e.node.children = ResponseToChildren(response, 2, parentID);
				let value = [...nodes];
				setNodes(value);
				//adjust the visual selection of the nodes after expanding. This eclude childre if the for example, 
				//the parent node is fully selected because the user delimitation is used to select.
				PreselectOnExpand(e.node);


			});
		} else if (level == 2) {
			delimitationService
				.getNationalLocalVotingDistrict(isNational, parentID)
				.then((response) => {
					e.node.children = ResponseToChildren(response, 3, parentID);
					let value = [...nodes];

					setNodes(value);
					//adjust the visual selection of the nodes after expanding. This eclude childre if the for example, 
					//the parent node is fully selected because the user delimitation is used to select.
					PreselectOnExpand(e.node);

				})
				.catch((err) => { });
		} else if (level == 3) {
			delimitationService
				.getNationalLocalgetRegistrationCentres(isNational, parentID)
				.then((response) => {
					e.node.children = ResponseToChildren(response, 4, parentID);
					let value = [...nodes];
					setNodes(value);

					//adjust the visual selection of the nodes after expanding. This eclude childre if the for example, 
					//the parent node is fully selected because the user delimitation is used to select.
					PreselectOnExpand(e.node);

				})
				.catch((err) => { });
		}
	}

	return (
		<Dialog
			draggable={false}
			header={
				<>
					<span>Select User Demarcation</span>
				</>
			}
			footer={
				<>
					<Button onClick={submit} className="p-button-primary" type="button" label="Submit" disabled={isValid()} />
					<Button onClick={onHide} className="p-button-danger" type="button" label="Cancel" />
				</>
			}
			visible={show}
			onHide={(e) => {
				onHide();
			}}
			onShow={() => {
				setNodes([]);
				setSelectedKeys({});
				setOldSelectedKeys({});
				getDistricts();
			}}
		>
			<div className="grid">
				<div className="col-12 lg:col-12">
					<Toast ref={toast} />
					<form>
						<TabView>
							<TabPanel>
								<Tree
									loading={loading}
									value={nodes}
									selectionMode="checkbox"
									selectionKeys={selectedKeys}
									onSelect={onSelect}
									onUnselect={onUnselect}
									onSelectionChange={(e, r) => {
										SetSelectedNodesIds(e.value);
									}}
									onExpand={(e) => {
										NodeExand(e);
									}}
									className="w-full" // md:w-30rem"
								/>
							</TabPanel>
						</TabView>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
